



<div class="centered">

<mat-card *ngIf="showLogin" class="speech-bubble">
  <table style="width: 100%; padding: 0px; margin: 0px">
    <tr>
      <td class="upperTd" >
        <div class="maherlogo"></div>
        <div class="titleFont" style="padding-bottom: 10px; padding-top: 50px; text-align: center">Login </div>
        <form  [formGroup]="myForm" autocomplete="off"   novalidate>
          <table  class="table-fill">
            <td>
              <mat-form-field appearance="outline" style="min-width: 90%;" floatLabel="always" >
                <mat-label>Username</mat-label>
                <input maxlength="30" #username1 oninput="this.value = this.value.toUpperCase()" matInput    formControlName="username" [disabled]="submitted"/>
              </mat-form-field>
              <span *ngIf="f.username.errors" class="invalid-feedback">
                      <div class="errorDiv2" *ngIf="f.username.errors?.pattern">Alphanumeric Only</div>
                      <div class="errorDiv2"  *ngIf="f.username.errors.required && submitted">Username Required</div>
              </span>

            </td>
            <tr>
              <td>
                <mat-form-field appearance="outline"  style="min-width: 90%;" floatLabel="always">
                  <mat-label>Password</mat-label>
                  <input maxlength="100" matInput  [type]="activePass ? 'password' : 'text'"   formControlName="password"/>
                  <a matSuffix matTooltip="show/hide password" (click)="showPassword()" style="font-size: 13px; cursor: pointer">
                    <a *ngIf="activePass" >SHOW </a>
                    <a *ngIf="!activePass" >HIDE </a>
                  </a>
                </mat-form-field>
                <span *ngIf="f.password.errors" class="invalid-feedback">
                    <div class="errorDiv2" *ngIf="f.password.errors?.required && submitted">Password Required</div>
                    <div class="errorDiv2" *ngIf="f.password.errors?.pattern">Spaces Not Allowed</div>

                </span>
                <div class="errorDiv2" *ngIf="submitted && errorFound">{{errorOut}}</div>
              </td>
            </tr>
          </table>
        </form>

        <div style="padding-top: 20%; text-align: center">
            <button mat-raised-button class="blueButton" (click)="login()" color="primary">Login</button>
        </div>
        <div class="div-forgot"(click)="forgot()" style="padding-bottom: 10px; padding-top: 30px; text-align: center; color: #E61E00; ">Forgot Password? </div>
      </td>

      <td class="lowerTd daPic">
          <div class="lowerCaseLetters" style="padding-left: 20px; padding-top: 50%">Welcome!</div>
      </td>

    </tr>

  </table>

</mat-card>
</div>
